import React from "react";
import { Helmet } from "react-helmet";

import MainLayout from "src/components/MainLayout";
import Benefits from "./Benefits";
import Title from "./CareerTitle";
import Search from "./Search";
import styled from "styled-components";
import background from "src/assets/images/NewScene/background_web_red.svg";
import imgpsh from "src/assets/images/careers/imgpsh.png";
import imgpsh_fullsize from "src/assets/images/careers/imgpsh_fullsize.png";
import { Col, Row } from "antd";

export const paramCareer = "/career";
const Wrapper = styled.section`
  background: url(${background}) no-repeat center;
  background-size: cover;
  width: 100vw;
`;
const ImgTitle = styled.img`
  width: 90%;
`;
const Content = styled.section`
  padding-top: 70px;
`;
const CareersPage: React.FC = () => {
  return (
    <MainLayout>
      <Wrapper>
        <Helmet>
          <meta
            name="description"
            content="Do you want to lead in blockchain technology and gamefi?, apply to join Senspark today."
          />
          <title>Recruitment | Join Senspark to explore gamefi</title>
          <meta
            property="og:title"
            content="Recruitment | Join Senspark to explore gamefi"
          />
          <meta
            property="og:image"
            content="https://i.ibb.co/Z2GmbX0/Thumbnail-Careeres.png"
          />
          <meta
            property="og:image:secure_url"
            content="https://i.ibb.co/Z2GmbX0/Thumbnail-Careeres.png"
          />
        </Helmet>
        <Row justify="space-between">
          <Col xs={4}>
            <div style={{ display: "flex", justifyContent: "right" , marginTop:'50px'}}>
              <ImgTitle src={imgpsh_fullsize} alt="" />
            </div>
          </Col>
          <Col xs={16}>
            <Content>
              <Title />
              <Search />
              <Benefits />
            </Content>
          </Col>
          <Col xs={4}>
            <div style={{ display: "flex", justifyContent: "left" , marginTop:'20px'}}>
              <ImgTitle src={imgpsh} alt="" />
            </div>
          </Col>
        </Row>
      </Wrapper>
    </MainLayout>
  );
};

export default CareersPage;
